export const content = {
    header:{
        home:{
            'en': 'Home',
            'fr': "Acceuille"
        },
        services:{
            'en': 'Services',
            'fr': 'Services'
        },
        schools:{
            en: 'Schools',
            fr: 'Écoles'
        },
        visa:{
            en: 'Visa programs',
            fr: 'Programmes de visas'
        },
        gallery: {
            en: 'Gallery',
            fr: 'Galerie'
        }
    }
}